export const serviceKeySelector = (state, { serviceKeyId }) => state.entities.serviceKeys.byId[serviceKeyId];
